// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class NotificationChannelResource extends Resource {
    basePath: string = 'notifications/notification-channels/';

    objectPath: string = 'notifications/notification-channels/{ident}/';
}
